import "./ProductSeperator.scss";

const ProductSeperator = () => <hr className="productSeperator" />;

export default ProductSeperator;
